<template>
  <el-pagination
    class="right"
    :page-size="records"
    background
    @current-change="fetch"
    @size-change="change"
    :current-page.sync="page"
    layout="sizes, prev, pager, next"
    :page-sizes="[
      50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 1000,
    ]"
    :total="total"
  ></el-pagination>
</template>

<script>
export default {
  name: "ShippingHeaderPagination",
  props: ["total"],
  data() {
    return {
      records: 50,
      page: 1,
    }
  },
  methods: {
    fetch() {
      this.$emit("fetch", this.records, this.page);
    },
    change(size) {
      this.records = size;
      this.fetch();
    },
  }
}
</script>